import { render, staticRenderFns } from "./turetiket.vue?vue&type=template&id=37d52204"
import script from "./turetiket.vue?vue&type=script&lang=js"
export * from "./turetiket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports